export default "__VITE_ASSET__DlaGenc$__"